import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  isSentApprovation: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action) => ({ ...state, ...action.payload }),
    resetAuth: () => initialState,
  },
});

export const { updateUser, resetAuth } = userSlice.actions;
export default userSlice.reducer;
